import etImg from '../img/et.png';
import gpImg from '../img/gp.png';
import ptImg from '../img/pt.png';
import mas10Img from '../img/mas10.png';
import trainerImg from '../img/trainer.png';
import golfImg from '../img/golf.png';

export interface CaseStudy {
  title: string;
  url: string;
  description: string;
  imageUrl?: string;
  hidden?: boolean;
  translationKey?: string;
}

export const CASE_STUDIES: CaseStudy[] = [
  {
    title: "Endurance Tool",
    url: "https://endurance-tool.com",
    description: "Plataforma de planificación y seguimiento para deportes de resistencia, con analítica avanzada y automatizaciones para coaches.",
    imageUrl: etImg,
    translationKey: "enduranceTool"
  },
  {
    title: "+10",
    url: "https://mas10.ar",
    description: "AI-driven community platform making amateur soccer visible, connected, and funded.",
    imageUrl: mas10Img,
    translationKey: "mas10"
  },
  {
    title: "+Trainer",
    url: "https://mastrainerapp.com",
    description: "Entrenamiento personalizado con IA: planes dinámicos, readiness e insights en tiempo real para atletas y coaches.",
    imageUrl: trainerImg,
    translationKey: "trainer"
  },
  {
    title: "Gol Popular",
    url: "https://golpopular.com",
    description: "AI powered media studio, que ofrece a periodistas y creadores emergentes un portal de noticias, un canal de streaming y herramientas para cubrir y gestionar el fútbol amateur.",
    imageUrl: gpImg,
    translationKey: "golPopular"
  },
  {
    title: "ProTorneos",
    url: "https://protorneos.com",
    description: "Gestión integral de ligas y torneos: fixtures, pagos, reglamentos, sponsors y reportes en un solo backoffice.",
    imageUrl: ptImg,
    translationKey: "proTorneos"
  },
  {
    title: "Plus Golf",
    url: "https://plus.golf/",
    description: "Experiencias y analítica para golf: registro de rondas, métricas clave y activaciones para comunidades de jugadores.",
    imageUrl: golfImg,
    translationKey: "plusGolf"
  },
  {
    title: "Motivia",
    url: "https://motivia.co",
    description: "Plataforma de hábitos y motivación aplicada al deporte y bienestar, con campañas y seguimiento multi-canal.",
    hidden: true,
    translationKey: "motivia"
  }
];
